export const userRoles = [
  { value: "", label: "-- Выберите национальность --", disabled: true },
  { value: "admin", label: "Admin" },
  { value: "sub-admin", label: "Sub Admin" },

  { value: "application-hr", label: "Application HR" },
  { value: "malta-application-curator", label: "Malta Application Curator" },
  { value: "malta-application-employee", label: "Malta Application Employee" },
  { value: "ukraine-application-curator", label: "Ukraine Application Curator" },
  { value: "ukraine-application-employee", label: "Ukraine Application Employee" },
  { value: "poland-application-curator", label: "Poland Application Curator" },
  { value: "poland-application-employee", label: "Poland Application Employee" },

  { value: "documents-hr", label: "Documents HR" },
  { value: "malta-documents-curator", label: "Malta Documents Curator" },
  { value: "malta-documents-employee", label: "Malta Documents Employee" },
  { value: "ukraine-documents-curator", label: "Ukraine Documents Curator" },
  { value: "ukraine-documents-employee", label: "Ukraine Documents Employee" },
  { value: "poland-documents-curator", label: "Poland Documents Curator" },
  { value: "poland-documents-employee", label: "Poland Documents Employee" },
];
